// extracted by mini-css-extract-plugin
export default {"buttons":"ButtonPair_buttons__psBge","backButton":"ButtonPair_backButton__Bgwd0","forwardButton":"ButtonPair_forwardButton__wR8vj"};